import type {Data, Part, PartExpand, Schema, SeparatedParts} from '../types';
import type {PartVisitor} from './types';
import {evaluateCondition} from './evaluateCondition';

export const visitVisibleSchemaParts = (
  data: Data,
  relatedScope: Data,
  schema: Schema,
  visitor: PartVisitor,
) => {
  return visitVisibleParts(schema.parts, data, '', data, relatedScope, visitor);
};

export const visitVisibleParts = (
  parts: SeparatedParts,
  data: Data,
  dataPath: string,
  globalScope: Data | undefined,
  relatedScope: Data | undefined,
  visitor: PartVisitor,
) => {
  parts.forEach(part =>
    Array.isArray(part)
      ? visitVisibleParts(
          part,
          data,
          dataPath,
          globalScope,
          relatedScope,
          visitor,
        )
      : part.type !== 'separator' && part.type !== 'action'
        ? visitVisiblePart(
            part,
            data,
            dataPath,
            globalScope,
            relatedScope,
            visitor,
          )
        : undefined,
  );
};

export const visitVisiblePart = (
  part: Part,
  data: Data,
  dataPath: string,
  globalScope: Data | undefined,
  relatedScope: Data | undefined,
  visitor: PartVisitor,
) => {
  const partPath = (
    dataPath ? `${dataPath}.${part.name}` : (part.name ?? '')
  ) as string;

  switch (part.type) {
    case 'schema': {
      visitor(part, partPath);
      visitVisibleParts(
        part.parts,
        data,
        partPath,
        globalScope,
        relatedScope,
        visitor,
      );
      return;
    }

    case 'expand': {
      return visitVisibleExpandPart(
        part,
        data,
        dataPath,
        globalScope,
        relatedScope,
        visitor,
      );
    }

    default: {
      visitor(
        part,
        partPath,
        //context
      );
    }
  }
};

export const visitVisibleExpandPart = (
  part: PartExpand,
  data: Data,
  dataPath: string,
  globalScope: Data | undefined,
  relatedScope: Data | undefined,
  visitor: PartVisitor,
) => {
  // Determine active case, if any
  const activeCase = part.when.find(w =>
    evaluateCondition(w.condition, {
      valuePath: dataPath,
      localScope: data,
      globalScope,
      relatedScope,
    }),
  );

  const activeParts = activeCase ? activeCase.parts : part.default;
  activeParts
    ? visitVisibleParts(
        activeParts,
        data,
        dataPath,
        globalScope,
        relatedScope,
        visitor,
      )
    : undefined;
};
